export default __webpack_public_path__ + "static/media/24.fab811f9.svg";